// import React, { useEffect, useMemo, useState } from "react";
// import {
//   Alert,
//   Box,
//   Button,
//   Card,
//   CardContent,
//   Chip,
//   CircularProgress,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Divider,
//   FormControl,
//   FormControlLabel,
//   Grid,
//   IconButton,
//   InputAdornment,
//   InputLabel,
//   MenuItem,
//   Select,
//   Snackbar,
//   Stack,
//   Switch,
//   Tab,
//   Tabs,
//   TextField,
//   Tooltip,
//   Typography,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   Paper,
// } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";
// import SaveIcon from "@mui/icons-material/Save";
// import RefreshIcon from "@mui/icons-material/Refresh";
// import DeleteIcon from "@mui/icons-material/Delete";
// import EditIcon from "@mui/icons-material/Edit";
// import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
// import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import HistoryIcon from "@mui/icons-material/History";
// import LanguageIcon from "@mui/icons-material/Language";
// import NotesIcon from "@mui/icons-material/Notes";
// import SearchIcon from "@mui/icons-material/Search";
// import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

// import { getDecryptedAccessToken } from "../../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
// import ApiServices from "../../../../Utils/ApiServices/ApiServices";

// const STATUS_OPTIONS = ["pending", "in_progress", "completed", "deployed"];
// const CURRENCY_OPTIONS = ["INR", "USD", "EUR", "GBP", "AUD", "CAD"];

// const initialWebsiteForm = {
//   website_url: "",
//   domain_provider: "",
//   domain_login_url: "",
//   domain_username: "",
//   domain_password: "",
//   hosting_provider: "",
//   hosting_login_url: "",
//   hosting_username: "",
//   hosting_password: "",
//   notes: "",
// };

// const initialChangeRequestForm = {
//   title: "",
//   description: "",
//   requested_by: "",
//   status: "pending",
//   internal_notes: "",
// };

// const initialVersionForm = {
//   change_summary: "",
//   files_changed: "",
//   deployed_by: "",
//   deployed_at: "",
// };

// const initialBillingForm = {
//   hours_spent: "",
//   rate_per_hour: "",
//   flat_fee: "",
//   currency: "INR",
//   is_invoiced: false,
//   invoice_number: "",
//   invoice_date: "",
//   notes: "",
// };

// const sectionTitleSx = {
//   fontWeight: 700,
//   fontSize: "1.05rem",
//   color: "#103b36",
// };

// const getStatusChipColor = (status) => {
//   switch (status) {
//     case "pending":
//       return "warning";
//     case "in_progress":
//       return "info";
//     case "completed":
//       return "success";
//     case "deployed":
//       return "secondary";
//     default:
//       return "default";
//   }
// };

// const isValidUrl = (value) => {
//   if (!value) return true;
//   try {
//     const parsed = new URL(value);
//     return ["http:", "https:"].includes(parsed.protocol);
//   } catch {
//     return false;
//   }
// };

// const isValidEmail = (value) => {
//   if (!value) return true;
//   return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
// };

// const isValidDomainOrWebsite = (value) => {
//   if (!value) return true;
//   const domainPattern =
//     /^(https?:\/\/)?(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})(:\d+)?(\/.*)?$/;
//   return domainPattern.test(value.trim());
// };

// const numericOnlyString = (value) => value.replace(/[^\d.]/g, "");

// const toISODateTimeLocal = (value) => {
//   if (!value) return "";
//   const d = new Date(value);
//   if (Number.isNaN(d.getTime())) return "";
//   const pad = (n) => `${n}`.padStart(2, "0");
//   return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
//     d.getHours()
//   )}:${pad(d.getMinutes())}`;
// };

// const formatDateTime = (value) => {
//   if (!value) return "-";
//   const date = new Date(value);
//   if (Number.isNaN(date.getTime())) return value;
//   return date.toLocaleString();
// };

// const formatDate = (value) => {
//   if (!value) return "-";
//   const date = new Date(value);
//   if (Number.isNaN(date.getTime())) return value;
//   return date.toLocaleDateString();
// };

// const safeArray = (value) => (Array.isArray(value) ? value : []);

// const WebsiteManagement = () => {
//   const clientId = sessionStorage.getItem("activeClientId");


//   const authHeaderstoken = getDecryptedAccessToken();

//     const  token = useMemo(
//       () => ({
//         Authorization: `Bearer ${authHeaderstoken}`,
//         "Content-Type": "application/json",
//       }),
//       [authHeaderstoken]
//     );

//   const [tabValue, setTabValue] = useState(0);
//   const [loadingPage, setLoadingPage] = useState(false);

//   const [websiteRecord, setWebsiteRecord] = useState(null);
//   const [websiteExists, setWebsiteExists] = useState(false);
//   const [websiteForm, setWebsiteForm] = useState(initialWebsiteForm);
//   const [websiteErrors, setWebsiteErrors] = useState({});

//   const [changeRequests, setChangeRequests] = useState([]);
//   const [changeRequestFilter, setChangeRequestFilter] = useState("");
//   const [changeRequestSearch, setChangeRequestSearch] = useState("");
//   const [selectedChangeRequest, setSelectedChangeRequest] = useState(null);

//   const [changeRequestDialogOpen, setChangeRequestDialogOpen] = useState(false);
//   const [changeRequestMode, setChangeRequestMode] = useState("create");
//   const [changeRequestForm, setChangeRequestForm] = useState(initialChangeRequestForm);
//   const [changeRequestErrors, setChangeRequestErrors] = useState({});
//   const [changeRequestSaving, setChangeRequestSaving] = useState(false);

//   const [versionDialogOpen, setVersionDialogOpen] = useState(false);
//   const [versionForm, setVersionForm] = useState(initialVersionForm);
//   const [versionErrors, setVersionErrors] = useState({});
//   const [versionSaving, setVersionSaving] = useState(false);

//   const [billingDialogOpen, setBillingDialogOpen] = useState(false);
//   const [billingMode, setBillingMode] = useState("create");
//   const [billingForm, setBillingForm] = useState(initialBillingForm);
//   const [billingErrors, setBillingErrors] = useState({});
//   const [billingSaving, setBillingSaving] = useState(false);

//   const [billingSummary, setBillingSummary] = useState(null);

//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     severity: "success",
//     message: "",
//   });

//   const baseUrl = useMemo(
//     () => `/api/v1/clients/${clientId}`,
//     [clientId]
//   );

//   const showSnackbar = (message, severity = "success") => {
//     setSnackbar({ open: true, message, severity });
//   };

//   const closeSnackbar = () => {
//     setSnackbar((prev) => ({ ...prev, open: false }));
//   };

//   const handleApiError = (error, fallbackMessage) => {
//     const message =
//       error?.response?.data?.detail ||
//       error?.response?.data?.message ||
//       error?.message ||
//       fallbackMessage;
//     showSnackbar(message, "error");
//   };

//   const apiGet = async (url) => {
//     return ApiServices.get(url, token);
//   };

//   const apiPost = async (url, payload) => {
//     return ApiServices.post(url, payload, token);
//   };

//   const apiPut = async (url, payload) => {
//     return ApiServices.put(url, payload, token);
//   };

//   const apiPatch = async (url, payload) => {
//     return ApiServices.patch(url, payload, token);
//   };

//   const apiDelete = async (url) => {
//     return ApiServices.delete(url, token);
//   };

//   const fetchWebsite = async () => {
//     try {
//       const res = await apiGet(`${baseUrl}/website/`);
//       const data = res?.data || {};
//       const exists = data && Object.keys(data).length > 0;
//       setWebsiteExists(exists);
//       setWebsiteRecord(exists ? data : null);
//       setWebsiteForm({
//         website_url: data?.website_url || "",
//         domain_provider: data?.domain_provider || "",
//         domain_login_url: data?.domain_login_url || "",
//         domain_username: data?.domain_username || "",
//         domain_password: "",
//         hosting_provider: data?.hosting_provider || "",
//         hosting_login_url: data?.hosting_login_url || "",
//         hosting_username: data?.hosting_username || "",
//         hosting_password: "",
//         notes: data?.notes || "",
//       });
//     } catch (error) {
//       handleApiError(error, "Failed to load website credentials.");
//     }
//   };

//   const fetchChangeRequests = async () => {
//     try {
//       const query = changeRequestFilter ? `?status=${changeRequestFilter}` : "";
//       const res = await apiGet(`${baseUrl}/change-requests/${query}`);
//       setChangeRequests(Array.isArray(res?.data) ? res.data : []);
//     } catch (error) {
//       handleApiError(error, "Failed to load change requests.");
//     }
//   };

//   const fetchBillingSummary = async () => {
//     try {
//       const res = await apiGet(`${baseUrl}/billing-summary/`);
//       setBillingSummary(res?.data || null);
//     } catch (error) {
//       handleApiError(error, "Failed to load billing summary.");
//     }
//   };

//   const fetchAll = async () => {
//     setLoadingPage(true);
//     try {
//       await Promise.all([fetchWebsite(), fetchChangeRequests(), fetchBillingSummary()]);
//     } finally {
//       setLoadingPage(false);
//     }
//   };

//   useEffect(() => {
//     if (!clientId || !token) {
//       showSnackbar("Missing client or token.", "error");
//       return;
//     }
//     fetchAll();
//   }, [clientId, token]);

//   useEffect(() => {
//     if (clientId && token) {
//       fetchChangeRequests();
//     }
//   }, [changeRequestFilter]);

//   const validateWebsiteForm = () => {
//     const errors = {};

//     if (websiteForm.website_url && !isValidUrl(websiteForm.website_url)) {
//       errors.website_url = "Enter a valid website URL starting with http or https.";
//     }

//     if (websiteForm.domain_login_url && !isValidUrl(websiteForm.domain_login_url)) {
//       errors.domain_login_url = "Enter a valid domain login URL.";
//     }

//     if (websiteForm.hosting_login_url && !isValidUrl(websiteForm.hosting_login_url)) {
//       errors.hosting_login_url = "Enter a valid hosting login URL.";
//     }

//     if (websiteForm.domain_username && websiteForm.domain_username.includes("@")) {
//       if (!isValidEmail(websiteForm.domain_username)) {
//         errors.domain_username = "Enter a valid email.";
//       }
//     }

//     if (websiteForm.hosting_username && websiteForm.hosting_username.includes("@")) {
//       if (!isValidEmail(websiteForm.hosting_username)) {
//         errors.hosting_username = "Enter a valid email.";
//       }
//     }

//     if (websiteForm.website_url && !isValidDomainOrWebsite(websiteForm.website_url)) {
//       errors.website_url = "Enter a valid website URL or domain.";
//     }

//     setWebsiteErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const validateChangeRequestForm = () => {
//     const errors = {};

//     if (!changeRequestForm.title.trim()) {
//       errors.title = "Title is required.";
//     }

//     if (!changeRequestForm.description.trim()) {
//       errors.description = "Description is required.";
//     }

//     if (!changeRequestForm.requested_by.trim()) {
//       errors.requested_by = "Requested by is required.";
//     }

//     if (!STATUS_OPTIONS.includes(changeRequestForm.status)) {
//       errors.status = "Select a valid status.";
//     }

//     setChangeRequestErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const validateVersionForm = () => {
//     const errors = {};

//     if (!versionForm.change_summary.trim()) {
//       errors.change_summary = "Change summary is required.";
//     }

//     if (versionForm.deployed_by && versionForm.deployed_by.includes("@")) {
//       if (!isValidEmail(versionForm.deployed_by)) {
//         errors.deployed_by = "Enter a valid email.";
//       }
//     }

//     setVersionErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const validateBillingForm = () => {
//     const errors = {};

//     if (billingForm.hours_spent !== "" && Number(billingForm.hours_spent) < 0) {
//       errors.hours_spent = "Hours spent cannot be negative.";
//     }

//     if (billingForm.rate_per_hour !== "" && Number(billingForm.rate_per_hour) < 0) {
//       errors.rate_per_hour = "Rate cannot be negative.";
//     }

//     if (billingForm.flat_fee !== "" && Number(billingForm.flat_fee) < 0) {
//       errors.flat_fee = "Flat fee cannot be negative.";
//     }

//     if (billingForm.invoice_number && billingForm.invoice_number.length > 50) {
//       errors.invoice_number = "Invoice number is too long.";
//     }

//     if (billingForm.is_invoiced && !billingForm.invoice_number.trim()) {
//       errors.invoice_number = "Invoice number is required when invoiced is enabled.";
//     }

//     if (billingForm.is_invoiced && !billingForm.invoice_date) {
//       errors.invoice_date = "Invoice date is required when invoiced is enabled.";
//     }

//     setBillingErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleWebsiteChange = (field, value) => {
//     setWebsiteForm((prev) => ({ ...prev, [field]: value }));
//     setWebsiteErrors((prev) => ({ ...prev, [field]: "" }));
//   };

//   const handleChangeRequestChange = (field, value) => {
//     setChangeRequestForm((prev) => ({ ...prev, [field]: value }));
//     setChangeRequestErrors((prev) => ({ ...prev, [field]: "" }));
//   };

//   const handleVersionChange = (field, value) => {
//     setVersionForm((prev) => ({ ...prev, [field]: value }));
//     setVersionErrors((prev) => ({ ...prev, [field]: "" }));
//   };

//   const handleBillingChange = (field, value) => {
//     setBillingForm((prev) => ({ ...prev, [field]: value }));
//     setBillingErrors((prev) => ({ ...prev, [field]: "" }));
//   };

//   const handleWebsiteSave = async () => {
//     if (!validateWebsiteForm()) return;

//     const payload = { ...websiteForm };

//     if (!payload.domain_password) delete payload.domain_password;
//     if (!payload.hosting_password) delete payload.hosting_password;

//     Object.keys(payload).forEach((key) => {
//       if (payload[key] === "") payload[key] = "";
//     });

//     try {
//       if (websiteExists) {
//         await apiPatch(`${baseUrl}/website/`, payload);
//         showSnackbar("Website credentials updated successfully.");
//       } else {
//         await apiPost(`${baseUrl}/website/`, payload);
//         showSnackbar("Website credentials created successfully.");
//       }
//       await fetchWebsite();
//     } catch (error) {
//       handleApiError(error, "Failed to save website credentials.");
//     }
//   };

//   const openCreateChangeRequestDialog = () => {
//     setChangeRequestMode("create");
//     setChangeRequestForm(initialChangeRequestForm);
//     setChangeRequestErrors({});
//     setChangeRequestDialogOpen(true);
//   };

//   const openEditChangeRequestDialog = (item) => {
//     setSelectedChangeRequest(item);
//     setChangeRequestMode("edit");
//     setChangeRequestForm({
//       title: item?.title || "",
//       description: item?.description || "",
//       requested_by: item?.requested_by || "",
//       status: item?.status || "pending",
//       internal_notes: item?.internal_notes || "",
//     });
//     setChangeRequestErrors({});
//     setChangeRequestDialogOpen(true);
//   };

//   const handleSaveChangeRequest = async () => {
//     if (!validateChangeRequestForm()) return;

//     setChangeRequestSaving(true);
//     try {
//       const payload = {
//         title: changeRequestForm.title.trim(),
//         description: changeRequestForm.description.trim(),
//         requested_by: changeRequestForm.requested_by.trim(),
//         status: changeRequestForm.status,
//         internal_notes: changeRequestForm.internal_notes?.trim() || "",
//       };

//       if (changeRequestMode === "create") {
//         await apiPost(`${baseUrl}/change-requests/`, payload);
//         showSnackbar("Change request created successfully.");
//       } else {
//         await apiPatch(
//           `${baseUrl}/change-requests/${selectedChangeRequest?.id}/`,
//           payload
//         );
//         showSnackbar("Change request updated successfully.");
//       }

//       setChangeRequestDialogOpen(false);
//       await fetchChangeRequests();
//       await fetchBillingSummary();
//     } catch (error) {
//       handleApiError(error, "Failed to save change request.");
//     } finally {
//       setChangeRequestSaving(false);
//     }
//   };

//   const handleDeleteChangeRequest = async (item) => {
//     const confirmed = window.confirm(
//       `Delete change request "${item?.title}"? This will also delete versions and billing.`
//     );
//     if (!confirmed) return;

//     try {
//       await apiDelete(`${baseUrl}/change-requests/${item?.id}/`);
//       showSnackbar("Change request deleted successfully.");
//       await fetchChangeRequests();
//       await fetchBillingSummary();
//     } catch (error) {
//       handleApiError(error, "Failed to delete change request.");
//     }
//   };

//   const handleQuickStatusUpdate = async (item, status) => {
//     try {
//       await apiPatch(`${baseUrl}/change-requests/${item?.id}/`, {
//         status,
//         internal_notes: item?.internal_notes || "",
//       });
//       showSnackbar(`Status updated to ${status}.`);
//       await fetchChangeRequests();
//       await fetchBillingSummary();
//     } catch (error) {
//       handleApiError(error, "Failed to update status.");
//     }
//   };

//   const openVersionDialog = (item) => {
//     setSelectedChangeRequest(item);
//     setVersionForm(initialVersionForm);
//     setVersionErrors({});
//     setVersionDialogOpen(true);
//   };

//   const handleSaveVersion = async () => {
//     if (!validateVersionForm()) return;

//     setVersionSaving(true);
//     try {
//       const payload = {
//         change_summary: versionForm.change_summary.trim(),
//         files_changed: versionForm.files_changed
//           ? versionForm.files_changed
//               .split(",")
//               .map((f) => f.trim())
//               .filter(Boolean)
//           : [],
//         deployed_by: versionForm.deployed_by.trim(),
//         deployed_at: versionForm.deployed_at
//           ? new Date(versionForm.deployed_at).toISOString()
//           : undefined,
//       };

//       if (!payload.deployed_by) delete payload.deployed_by;
//       if (!payload.deployed_at) delete payload.deployed_at;

//       await apiPost(
//         `${baseUrl}/change-requests/${selectedChangeRequest?.id}/versions/`,
//         payload
//       );

//       showSnackbar("Version added successfully.");
//       setVersionDialogOpen(false);
//       await fetchChangeRequests();
//     } catch (error) {
//       handleApiError(error, "Failed to add version.");
//     } finally {
//       setVersionSaving(false);
//     }
//   };

//   const openBillingDialog = async (item) => {
//     setSelectedChangeRequest(item);
//     setBillingErrors({});
//     try {
//       const res = await apiGet(
//         `${baseUrl}/change-requests/${item?.id}/billing/`
//       );
//       const data = res?.data || {};
//       const exists = data && Object.keys(data).length > 0;

//       setBillingMode(exists ? "edit" : "create");
//       setBillingForm({
//         hours_spent: data?.hours_spent ?? "",
//         rate_per_hour: data?.rate_per_hour ?? "",
//         flat_fee: data?.flat_fee ?? "",
//         currency: data?.currency || "INR",
//         is_invoiced: !!data?.is_invoiced,
//         invoice_number: data?.invoice_number || "",
//         invoice_date: data?.invoice_date || "",
//         notes: data?.notes || "",
//       });
//       setBillingDialogOpen(true);
//     } catch (error) {
//       handleApiError(error, "Failed to load billing.");
//     }
//   };

//   const handleSaveBilling = async () => {
//     if (!validateBillingForm()) return;

//     setBillingSaving(true);
//     try {
//       const payload = {
//         hours_spent:
//           billingForm.hours_spent === "" ? 0 : Number(billingForm.hours_spent),
//         rate_per_hour:
//           billingForm.rate_per_hour === "" ? 0 : Number(billingForm.rate_per_hour),
//         flat_fee: billingForm.flat_fee === "" ? 0 : Number(billingForm.flat_fee),
//         currency: billingForm.currency,
//         is_invoiced: !!billingForm.is_invoiced,
//         invoice_number: billingForm.invoice_number.trim(),
//         notes: billingForm.notes.trim(),
//       };

//       if (billingForm.invoice_date) {
//         payload.invoice_date = billingForm.invoice_date;
//       }

//       if (!payload.invoice_number) delete payload.invoice_number;
//       if (!payload.notes) delete payload.notes;
//       if (!payload.invoice_date) delete payload.invoice_date;

//       if (billingMode === "create") {
//         await apiPost(
//           `${baseUrl}/change-requests/${selectedChangeRequest?.id}/billing/`,
//           payload
//         );
//         showSnackbar("Billing created successfully.");
//       } else {
//         await apiPatch(
//           `${baseUrl}/change-requests/${selectedChangeRequest?.id}/billing/`,
//           payload
//         );
//         showSnackbar("Billing updated successfully.");
//       }

//       setBillingDialogOpen(false);
//       await fetchChangeRequests();
//       await fetchBillingSummary();
//     } catch (error) {
//       handleApiError(error, "Failed to save billing.");
//     } finally {
//       setBillingSaving(false);
//     }
//   };

//   const filteredChangeRequests = useMemo(() => {
//     const search = changeRequestSearch.trim().toLowerCase();
//     if (!search) return changeRequests;

//     return changeRequests.filter((item) => {
//       return (
//         item?.title?.toLowerCase().includes(search) ||
//         item?.description?.toLowerCase().includes(search) ||
//         item?.requested_by?.toLowerCase().includes(search) ||
//         item?.status?.toLowerCase().includes(search)
//       );
//     });
//   }, [changeRequests, changeRequestSearch]);

//   const renderWebsiteCredentials = () => {
//     return (
//       <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
//         <CardContent>
//           <Stack
//             direction={{ xs: "column", md: "row" }}
//             alignItems={{ xs: "flex-start", md: "center" }}
//             justifyContent="space-between"
//             spacing={2}
//             sx={{ mb: 3 }}
//           >
//             <Box>
//               <Typography sx={sectionTitleSx}>Website Credentials</Typography>
//               <Typography variant="body2" color="text.secondary">
//                 Store website, domain and hosting access details in one place.
//               </Typography>
//             </Box>

//             <Stack direction="row" spacing={1}>
//               <Button
//                 variant="outlined"
//                 startIcon={<RefreshIcon />}
//                 onClick={fetchWebsite}
//               >
//                 Refresh
//               </Button>
//               <Button
//                 variant="contained"
//                 startIcon={<SaveIcon />}
//                 onClick={handleWebsiteSave}
//               >
//                 {websiteExists ? "Update Credentials" : "Save Credentials"}
//               </Button>
//             </Stack>
//           </Stack>

//           <Grid container spacing={2.5}>
//             <Grid item xs={12}>
//               <Paper
//                 variant="outlined"
//                 sx={{
//                   p: 2,
//                   borderRadius: 2.5,
//                   bgcolor: "#f8fffd",
//                   borderColor: "#cdebe3",
//                 }}
//               >
//                 <Stack direction="row" spacing={1} alignItems="center">
//                   <LanguageIcon color="success" />
//                   <Box>
//                     <Typography fontWeight={700}>
//                       Website Access Information
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       Password fields are write-only. Keep them blank if you do not want to change them.
//                     </Typography>
//                   </Box>
//                 </Stack>
//               </Paper>
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 label="Website URL"
//                 placeholder="https://example.com"
//                 value={websiteForm.website_url}
//                 onChange={(e) => handleWebsiteChange("website_url", e.target.value)}
//                 error={!!websiteErrors.website_url}
//                 helperText={websiteErrors.website_url}
//               />
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 label="Domain Provider"
//                 placeholder="GoDaddy"
//                 value={websiteForm.domain_provider}
//                 onChange={(e) =>
//                   handleWebsiteChange("domain_provider", e.target.value)
//                 }
//               />
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 label="Domain Login URL"
//                 placeholder="https://dcc.godaddy.com"
//                 value={websiteForm.domain_login_url}
//                 onChange={(e) =>
//                   handleWebsiteChange("domain_login_url", e.target.value)
//                 }
//                 error={!!websiteErrors.domain_login_url}
//                 helperText={websiteErrors.domain_login_url}
//               />
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 label="Domain Username / Email"
//                 placeholder="admin@example.com"
//                 value={websiteForm.domain_username}
//                 onChange={(e) =>
//                   handleWebsiteChange("domain_username", e.target.value)
//                 }
//                 error={!!websiteErrors.domain_username}
//                 helperText={websiteErrors.domain_username}
//               />
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 type="password"
//                 label="Domain Password"
//                 placeholder="Enter only if changing"
//                 value={websiteForm.domain_password}
//                 onChange={(e) =>
//                   handleWebsiteChange("domain_password", e.target.value)
//                 }
//                 helperText="Leave blank to keep existing password unchanged."
//               />
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 label="Hosting Provider"
//                 placeholder="SiteGround"
//                 value={websiteForm.hosting_provider}
//                 onChange={(e) =>
//                   handleWebsiteChange("hosting_provider", e.target.value)
//                 }
//               />
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 label="Hosting Login URL"
//                 placeholder="https://app.siteground.com"
//                 value={websiteForm.hosting_login_url}
//                 onChange={(e) =>
//                   handleWebsiteChange("hosting_login_url", e.target.value)
//                 }
//                 error={!!websiteErrors.hosting_login_url}
//                 helperText={websiteErrors.hosting_login_url}
//               />
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 label="Hosting Username / Email"
//                 placeholder="hosting@example.com"
//                 value={websiteForm.hosting_username}
//                 onChange={(e) =>
//                   handleWebsiteChange("hosting_username", e.target.value)
//                 }
//                 error={!!websiteErrors.hosting_username}
//                 helperText={websiteErrors.hosting_username}
//               />
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 type="password"
//                 label="Hosting Password"
//                 placeholder="Enter only if changing"
//                 value={websiteForm.hosting_password}
//                 onChange={(e) =>
//                   handleWebsiteChange("hosting_password", e.target.value)
//                 }
//                 helperText="Leave blank to keep existing password unchanged."
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 multiline
//                 minRows={4}
//                 label="Notes"
//                 placeholder="Add renewal info, access notes, important remarks..."
//                 value={websiteForm.notes}
//                 onChange={(e) => handleWebsiteChange("notes", e.target.value)}
//               />
//             </Grid>
//           </Grid>
//         </CardContent>
//       </Card>
//     );
//   };

//   const renderChangeRequests = () => {
//     return (
//       <Stack spacing={2.5}>
//         <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
//           <CardContent>
//             <Stack
//               direction={{ xs: "column", md: "row" }}
//               justifyContent="space-between"
//               spacing={2}
//               sx={{ mb: 2 }}
//             >
//               <Box>
//                 <Typography sx={sectionTitleSx}>Change Requests</Typography>
//                 <Typography variant="body2" color="text.secondary">
//                   Track pending, in-progress, completed and deployed website updates.
//                 </Typography>
//               </Box>

//               <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
//                 <TextField
//                   size="small"
//                   placeholder="Search request..."
//                   value={changeRequestSearch}
//                   onChange={(e) => setChangeRequestSearch(e.target.value)}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <SearchIcon fontSize="small" />
//                       </InputAdornment>
//                     ),
//                   }}
//                 />

//                 <FormControl size="small" sx={{ minWidth: 180 }}>
//                   <InputLabel>Status Filter</InputLabel>
//                   <Select
//                     label="Status Filter"
//                     value={changeRequestFilter}
//                     onChange={(e) => setChangeRequestFilter(e.target.value)}
//                   >
//                     <MenuItem value="">All</MenuItem>
//                     {STATUS_OPTIONS.map((status) => (
//                       <MenuItem key={status} value={status}>
//                         {status}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>

//                 <Button
//                   variant="outlined"
//                   startIcon={<RefreshIcon />}
//                   onClick={fetchChangeRequests}
//                 >
//                   Refresh
//                 </Button>

//                 <Button
//                   variant="contained"
//                   startIcon={<AddIcon />}
//                   onClick={openCreateChangeRequestDialog}
//                 >
//                   Add Request
//                 </Button>
//               </Stack>
//             </Stack>

//             {filteredChangeRequests.length === 0 ? (
//               <Alert severity="info" sx={{ borderRadius: 2 }}>
//                 No change requests found.
//               </Alert>
//             ) : (
//               <Stack spacing={2}>
//                 {filteredChangeRequests.map((item) => (
//                   <Accordion
//                     key={item.id}
//                     sx={{
//                       borderRadius: "14px !important",
//                       boxShadow: 1,
//                       border: "1px solid #e6ecef",
//                     }}
//                   >
//                     <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//                       <Grid container spacing={2} alignItems="center">
//                         <Grid item xs={12} md={4}>
//                           <Typography fontWeight={700}>{item.title}</Typography>
//                           <Typography variant="body2" color="text.secondary">
//                             Requested by: {item.requested_by || "-"}
//                           </Typography>
//                         </Grid>

//                         <Grid item xs={12} md={3}>
//                           <Chip
//                             label={item.status}
//                             color={getStatusChipColor(item.status)}
//                             sx={{ textTransform: "capitalize", fontWeight: 700 }}
//                           />
//                         </Grid>

//                         <Grid item xs={12} md={5}>
//                           <Typography variant="body2" color="text.secondary">
//                             Requested: {formatDateTime(item.requested_at)}
//                           </Typography>
//                           <Typography variant="body2" color="text.secondary">
//                             Updated: {formatDateTime(item.updated_at)}
//                           </Typography>
//                         </Grid>
//                       </Grid>
//                     </AccordionSummary>

//                     <AccordionDetails>
//                       <Stack spacing={2}>
//                         <Paper
//                           variant="outlined"
//                           sx={{ p: 2, borderRadius: 2.5, bgcolor: "#fafcfd" }}
//                         >
//                           <Typography fontWeight={700} mb={0.5}>
//                             Description
//                           </Typography>
//                           <Typography variant="body2" color="text.secondary">
//                             {item.description || "-"}
//                           </Typography>

//                           <Divider sx={{ my: 1.5 }} />

//                           <Typography fontWeight={700} mb={0.5}>
//                             Internal Notes
//                           </Typography>
//                           <Typography variant="body2" color="text.secondary">
//                             {item.internal_notes || "-"}
//                           </Typography>

//                           <Divider sx={{ my: 1.5 }} />

//                           <Grid container spacing={1.5}>
//                             <Grid item xs={12} md={4}>
//                               <Typography variant="body2">
//                                 <strong>Completed At:</strong> {formatDateTime(item.completed_at)}
//                               </Typography>
//                             </Grid>
//                             <Grid item xs={12} md={4}>
//                               <Typography variant="body2">
//                                 <strong>Deployed At:</strong> {formatDateTime(item.deployed_at)}
//                               </Typography>
//                             </Grid>
//                             <Grid item xs={12} md={4}>
//                               <Typography variant="body2">
//                                 <strong>Created:</strong> {formatDateTime(item.created_at)}
//                               </Typography>
//                             </Grid>
//                           </Grid>
//                         </Paper>

//                         <Stack
//                           direction={{ xs: "column", md: "row" }}
//                           spacing={1}
//                           flexWrap="wrap"
//                         >
//                           <Button
//                             variant="outlined"
//                             startIcon={<EditIcon />}
//                             onClick={() => openEditChangeRequestDialog(item)}
//                           >
//                             Edit
//                           </Button>

//                           <Button
//                             variant="outlined"
//                             startIcon={<HistoryIcon />}
//                             onClick={() => openVersionDialog(item)}
//                           >
//                             Add Version
//                           </Button>

//                           <Button
//                             variant="outlined"
//                             startIcon={<ReceiptLongIcon />}
//                             onClick={() => openBillingDialog(item)}
//                           >
//                             Manage Billing
//                           </Button>

//                           {item.status !== "in_progress" && (
//                             <Button
//                               variant="outlined"
//                               onClick={() => handleQuickStatusUpdate(item, "in_progress")}
//                             >
//                               Mark In Progress
//                             </Button>
//                           )}

//                           {item.status !== "completed" && (
//                             <Button
//                               variant="outlined"
//                               onClick={() => handleQuickStatusUpdate(item, "completed")}
//                             >
//                               Mark Completed
//                             </Button>
//                           )}

//                           {item.status !== "deployed" && (
//                             <Button
//                               variant="contained"
//                               color="secondary"
//                               startIcon={<PublishedWithChangesIcon />}
//                               onClick={() => handleQuickStatusUpdate(item, "deployed")}
//                             >
//                               Mark Deployed
//                             </Button>
//                           )}

//                           <Button
//                             variant="outlined"
//                             color="error"
//                             startIcon={<DeleteIcon />}
//                             onClick={() => handleDeleteChangeRequest(item)}
//                           >
//                             Delete
//                           </Button>
//                         </Stack>

//                         <Grid container spacing={2}>
//                           <Grid item xs={12} md={6}>
//                             <Card variant="outlined" sx={{ borderRadius: 2.5 }}>
//                               <CardContent>
//                                 <Typography fontWeight={700} mb={1}>
//                                   Versions
//                                 </Typography>

//                                 {safeArray(item.versions).length === 0 ? (
//                                   <Typography variant="body2" color="text.secondary">
//                                     No versions added yet.
//                                   </Typography>
//                                 ) : (
//                                   <Stack spacing={1.5}>
//                                     {item.versions.map((version) => (
//                                       <Paper
//                                         key={version.id}
//                                         variant="outlined"
//                                         sx={{ p: 1.5, borderRadius: 2 }}
//                                       >
//                                         <Stack
//                                           direction="row"
//                                           justifyContent="space-between"
//                                           alignItems="center"
//                                           sx={{ mb: 0.5 }}
//                                         >
//                                           <Chip
//                                             size="small"
//                                             label={version.version_tag}
//                                             color="info"
//                                           />
//                                           <Typography variant="caption" color="text.secondary">
//                                             {formatDateTime(version.deployed_at)}
//                                           </Typography>
//                                         </Stack>

//                                         <Typography fontWeight={700} variant="body2">
//                                           {version.change_summary}
//                                         </Typography>

//                                         <Typography variant="body2" color="text.secondary" mt={0.5}>
//                                           <strong>Deployed By:</strong> {version.deployed_by || "-"}
//                                         </Typography>

//                                         <Typography variant="body2" color="text.secondary" mt={0.25}>
//                                           <strong>Files:</strong>{" "}
//                                           {safeArray(version.files_changed).length > 0
//                                             ? version.files_changed.join(", ")
//                                             : "-"}
//                                         </Typography>
//                                       </Paper>
//                                     ))}
//                                   </Stack>
//                                 )}
//                               </CardContent>
//                             </Card>
//                           </Grid>

//                           <Grid item xs={12} md={6}>
//                             <Card variant="outlined" sx={{ borderRadius: 2.5 }}>
//                               <CardContent>
//                                 <Typography fontWeight={700} mb={1}>
//                                   Billing
//                                 </Typography>

//                                 {item.billing ? (
//                                   <Stack spacing={0.75}>
//                                     <Typography variant="body2">
//                                       <strong>Hours Spent:</strong> {item.billing.hours_spent ?? "-"}
//                                     </Typography>
//                                     <Typography variant="body2">
//                                       <strong>Rate/Hour:</strong> {item.billing.rate_per_hour ?? "-"}
//                                     </Typography>
//                                     <Typography variant="body2">
//                                       <strong>Flat Fee:</strong> {item.billing.flat_fee ?? "-"}
//                                     </Typography>
//                                     <Typography variant="body2">
//                                       <strong>Total Amount:</strong> {item.billing.total_amount ?? "-"}{" "}
//                                       {item.billing.currency || ""}
//                                     </Typography>
//                                     <Typography variant="body2">
//                                       <strong>Invoiced:</strong>{" "}
//                                       {item.billing.is_invoiced ? "Yes" : "No"}
//                                     </Typography>
//                                     <Typography variant="body2">
//                                       <strong>Invoice Number:</strong>{" "}
//                                       {item.billing.invoice_number || "-"}
//                                     </Typography>
//                                     <Typography variant="body2">
//                                       <strong>Invoice Date:</strong>{" "}
//                                       {formatDate(item.billing.invoice_date)}
//                                     </Typography>
//                                     <Typography variant="body2">
//                                       <strong>Notes:</strong> {item.billing.notes || "-"}
//                                     </Typography>
//                                   </Stack>
//                                 ) : (
//                                   <Typography variant="body2" color="text.secondary">
//                                     No billing added yet.
//                                   </Typography>
//                                 )}
//                               </CardContent>
//                             </Card>
//                           </Grid>
//                         </Grid>
//                       </Stack>
//                     </AccordionDetails>
//                   </Accordion>
//                 ))}
//               </Stack>
//             )}
//           </CardContent>
//         </Card>
//       </Stack>
//     );
//   };

//   const renderBillingSummary = () => {
//     return (
//       <Stack spacing={2.5}>
//         <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
//           <CardContent>
//             <Stack
//               direction={{ xs: "column", md: "row" }}
//               justifyContent="space-between"
//               spacing={2}
//               sx={{ mb: 2 }}
//             >
//               <Box>
//                 <Typography sx={sectionTitleSx}>Billing Summary</Typography>
//                 <Typography variant="body2" color="text.secondary">
//                   View billed and unbilled totals for all website change requests.
//                 </Typography>
//               </Box>

//               <Button
//                 variant="outlined"
//                 startIcon={<RefreshIcon />}
//                 onClick={fetchBillingSummary}
//               >
//                 Refresh Summary
//               </Button>
//             </Stack>

//             {!billingSummary ? (
//               <Alert severity="info" sx={{ borderRadius: 2 }}>
//                 No billing summary available.
//               </Alert>
//             ) : (
//               <>
//                 <Grid container spacing={2} sx={{ mb: 2 }}>
//                   <Grid item xs={12} md={4}>
//                     <Paper
//                       variant="outlined"
//                       sx={{ p: 2, borderRadius: 2.5, bgcolor: "#f7fafb" }}
//                     >
//                       <Stack direction="row" spacing={1} alignItems="center">
//                         <AttachMoneyIcon color="success" />
//                         <Box>
//                           <Typography variant="body2" color="text.secondary">
//                             Total Billed
//                           </Typography>
//                           <Typography fontWeight={800} fontSize="1.2rem">
//                             {billingSummary.total_billed ?? 0} {billingSummary.currency || ""}
//                           </Typography>
//                         </Box>
//                       </Stack>
//                     </Paper>
//                   </Grid>

//                   <Grid item xs={12} md={4}>
//                     <Paper
//                       variant="outlined"
//                       sx={{ p: 2, borderRadius: 2.5, bgcolor: "#f7fafb" }}
//                     >
//                       <Stack direction="row" spacing={1} alignItems="center">
//                         <AttachMoneyIcon color="warning" />
//                         <Box>
//                           <Typography variant="body2" color="text.secondary">
//                             Total Unbilled
//                           </Typography>
//                           <Typography fontWeight={800} fontSize="1.2rem">
//                             {billingSummary.total_unbilled ?? 0} {billingSummary.currency || ""}
//                           </Typography>
//                         </Box>
//                       </Stack>
//                     </Paper>
//                   </Grid>

//                   <Grid item xs={12} md={4}>
//                     <Paper
//                       variant="outlined"
//                       sx={{ p: 2, borderRadius: 2.5, bgcolor: "#f7fafb" }}
//                     >
//                       <Stack direction="row" spacing={1} alignItems="center">
//                         <AttachMoneyIcon color="info" />
//                         <Box>
//                           <Typography variant="body2" color="text.secondary">
//                             Grand Total
//                           </Typography>
//                           <Typography fontWeight={800} fontSize="1.2rem">
//                             {billingSummary.grand_total ?? 0} {billingSummary.currency || ""}
//                           </Typography>
//                         </Box>
//                       </Stack>
//                     </Paper>
//                   </Grid>
//                 </Grid>

//                 <Card variant="outlined" sx={{ borderRadius: 2.5 }}>
//                   <CardContent>
//                     <Typography fontWeight={700} mb={1.5}>
//                       Billing Records
//                     </Typography>

//                     {safeArray(billingSummary.records).length === 0 ? (
//                       <Typography variant="body2" color="text.secondary">
//                         No records found.
//                       </Typography>
//                     ) : (
//                       <Stack spacing={1.5}>
//                         {billingSummary.records.map((record, index) => (
//                           <Paper
//                             key={`${record.change_request_id}-${index}`}
//                             variant="outlined"
//                             sx={{ p: 2, borderRadius: 2 }}
//                           >
//                             <Grid container spacing={1.25}>
//                               <Grid item xs={12} md={3}>
//                                 <Typography fontWeight={700}>
//                                   {record.title || "-"}
//                                 </Typography>
//                                 <Chip
//                                   size="small"
//                                   label={record.status || "-"}
//                                   color={getStatusChipColor(record.status)}
//                                   sx={{ mt: 0.75, textTransform: "capitalize" }}
//                                 />
//                               </Grid>

//                               <Grid item xs={12} md={3}>
//                                 <Typography variant="body2">
//                                   <strong>Hours:</strong> {record.hours_spent ?? 0}
//                                 </Typography>
//                                 <Typography variant="body2">
//                                   <strong>Rate:</strong> {record.rate_per_hour ?? 0}
//                                 </Typography>
//                                 <Typography variant="body2">
//                                   <strong>Flat Fee:</strong> {record.flat_fee ?? 0}
//                                 </Typography>
//                               </Grid>

//                               <Grid item xs={12} md={3}>
//                                 <Typography variant="body2">
//                                   <strong>Total:</strong> {record.total_amount ?? 0}{" "}
//                                   {record.currency || ""}
//                                 </Typography>
//                                 <Typography variant="body2">
//                                   <strong>Invoiced:</strong>{" "}
//                                   {record.is_invoiced ? "Yes" : "No"}
//                                 </Typography>
//                               </Grid>

//                               <Grid item xs={12} md={3}>
//                                 <Typography variant="body2">
//                                   <strong>Invoice No:</strong> {record.invoice_number || "-"}
//                                 </Typography>
//                                 <Typography variant="body2">
//                                   <strong>Invoice Date:</strong> {formatDate(record.invoice_date)}
//                                 </Typography>
//                               </Grid>
//                             </Grid>
//                           </Paper>
//                         ))}
//                       </Stack>
//                     )}
//                   </CardContent>
//                 </Card>
//               </>
//             )}
//           </CardContent>
//         </Card>
//       </Stack>
//     );
//   };

//   return (
//     <Box sx={{ p: { xs: 1.5, md: 3 }, bgcolor: "#f5f8fa", minHeight: "100%" }}>
//       <Card sx={{ borderRadius: 3, mb: 2.5, boxShadow: 3 }}>
//         <CardContent>
//           <Stack
//             direction={{ xs: "column", md: "row" }}
//             justifyContent="space-between"
//             spacing={2}
//             alignItems={{ xs: "flex-start", md: "center" }}
//           >
//             <Box>
//               <Typography variant="h5" fontWeight={800} color="#0f332f">
//                 Website Management
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 Manage website credentials, client change requests, versions, billing and summary.
//               </Typography>
//             </Box>

//             <Button
//               variant="outlined"
//               startIcon={<RefreshIcon />}
//               onClick={fetchAll}
//             >
//               Refresh All
//             </Button>
//           </Stack>
//         </CardContent>
//       </Card>

//       <Card sx={{ borderRadius: 3, boxShadow: 3, overflow: "hidden" }}>
//         <Box sx={{ borderBottom: "1px solid #e7ecef", bgcolor: "#ffffff" }}>
//           <Tabs
//             value={tabValue}
//             onChange={(_, value) => setTabValue(value)}
//             variant="scrollable"
//             scrollButtons="auto"
//           >
//             <Tab icon={<LanguageIcon />} iconPosition="start" label="Website Credentials" />
//             <Tab icon={<PublishedWithChangesIcon />} iconPosition="start" label="Change Requests" />
//             <Tab icon={<ReceiptLongIcon />} iconPosition="start" label="Billing Summary" />
//           </Tabs>
//         </Box>

//         <Box sx={{ p: { xs: 1.5, md: 2.5 } }}>
//           {loadingPage ? (
//             <Box
//               sx={{
//                 minHeight: 260,
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//               }}
//             >
//               <CircularProgress />
//             </Box>
//           ) : (
//             <>
//               {tabValue === 0 && renderWebsiteCredentials()}
//               {tabValue === 1 && renderChangeRequests()}
//               {tabValue === 2 && renderBillingSummary()}
//             </>
//           )}
//         </Box>
//       </Card>

//       <Dialog
//         open={changeRequestDialogOpen}
//         onClose={() => setChangeRequestDialogOpen(false)}
//         fullWidth
//         maxWidth="md"
//       >
//         <DialogTitle>
//           {changeRequestMode === "create" ? "Add Change Request" : "Edit Change Request"}
//         </DialogTitle>
//         <DialogContent dividers>
//           <Grid container spacing={2} sx={{ pt: 0.5 }}>
//             <Grid item xs={12} md={8}>
//               <TextField
//                 fullWidth
//                 label="Title"
//                 value={changeRequestForm.title}
//                 onChange={(e) => handleChangeRequestChange("title", e.target.value)}
//                 error={!!changeRequestErrors.title}
//                 helperText={changeRequestErrors.title}
//               />
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <FormControl fullWidth error={!!changeRequestErrors.status}>
//                 <InputLabel>Status</InputLabel>
//                 <Select
//                   label="Status"
//                   value={changeRequestForm.status}
//                   onChange={(e) => handleChangeRequestChange("status", e.target.value)}
//                 >
//                   {STATUS_OPTIONS.map((status) => (
//                     <MenuItem key={status} value={status}>
//                       {status}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 label="Requested By"
//                 placeholder="John Doe"
//                 value={changeRequestForm.requested_by}
//                 onChange={(e) => handleChangeRequestChange("requested_by", e.target.value)}
//                 error={!!changeRequestErrors.requested_by}
//                 helperText={changeRequestErrors.requested_by}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 multiline
//                 minRows={4}
//                 label="Description"
//                 value={changeRequestForm.description}
//                 onChange={(e) => handleChangeRequestChange("description", e.target.value)}
//                 error={!!changeRequestErrors.description}
//                 helperText={changeRequestErrors.description}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 multiline
//                 minRows={3}
//                 label="Internal Notes"
//                 value={changeRequestForm.internal_notes}
//                 onChange={(e) =>
//                   handleChangeRequestChange("internal_notes", e.target.value)
//                 }
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setChangeRequestDialogOpen(false)}>Cancel</Button>
//           <Button
//             variant="contained"
//             onClick={handleSaveChangeRequest}
//             disabled={changeRequestSaving}
//           >
//             {changeRequestSaving ? "Saving..." : "Save"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog
//         open={versionDialogOpen}
//         onClose={() => setVersionDialogOpen(false)}
//         fullWidth
//         maxWidth="md"
//       >
//         <DialogTitle>Add Version</DialogTitle>
//         <DialogContent dividers>
//           <Grid container spacing={2} sx={{ pt: 0.5 }}>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 multiline
//                 minRows={3}
//                 label="Change Summary"
//                 value={versionForm.change_summary}
//                 onChange={(e) => handleVersionChange("change_summary", e.target.value)}
//                 error={!!versionErrors.change_summary}
//                 helperText={versionErrors.change_summary}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Files Changed"
//                 placeholder="index.html, src/components/Hero.jsx"
//                 value={versionForm.files_changed}
//                 onChange={(e) => handleVersionChange("files_changed", e.target.value)}
//                 helperText="Enter comma separated file paths."
//               />
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 label="Deployed By"
//                 placeholder="dev@company.com"
//                 value={versionForm.deployed_by}
//                 onChange={(e) => handleVersionChange("deployed_by", e.target.value)}
//                 error={!!versionErrors.deployed_by}
//                 helperText={versionErrors.deployed_by}
//               />
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 type="datetime-local"
//                 label="Deployed At"
//                 InputLabelProps={{ shrink: true }}
//                 value={versionForm.deployed_at}
//                 onChange={(e) => handleVersionChange("deployed_at", e.target.value)}
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setVersionDialogOpen(false)}>Cancel</Button>
//           <Button
//             variant="contained"
//             onClick={handleSaveVersion}
//             disabled={versionSaving}
//           >
//             {versionSaving ? "Saving..." : "Save Version"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog
//         open={billingDialogOpen}
//         onClose={() => setBillingDialogOpen(false)}
//         fullWidth
//         maxWidth="md"
//       >
//         <DialogTitle>
//           {billingMode === "create" ? "Create Billing" : "Update Billing"}
//         </DialogTitle>
//         <DialogContent dividers>
//           <Grid container spacing={2} sx={{ pt: 0.5 }}>
//             <Grid item xs={12} md={4}>
//               <TextField
//                 fullWidth
//                 label="Hours Spent"
//                 value={billingForm.hours_spent}
//                 onChange={(e) =>
//                   handleBillingChange("hours_spent", numericOnlyString(e.target.value))
//                 }
//                 error={!!billingErrors.hours_spent}
//                 helperText={billingErrors.hours_spent || "Numbers only"}
//                 inputProps={{ inputMode: "decimal" }}
//               />
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <TextField
//                 fullWidth
//                 label="Rate Per Hour"
//                 value={billingForm.rate_per_hour}
//                 onChange={(e) =>
//                   handleBillingChange("rate_per_hour", numericOnlyString(e.target.value))
//                 }
//                 error={!!billingErrors.rate_per_hour}
//                 helperText={billingErrors.rate_per_hour || "Numbers only"}
//                 inputProps={{ inputMode: "decimal" }}
//               />
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <TextField
//                 fullWidth
//                 label="Flat Fee"
//                 value={billingForm.flat_fee}
//                 onChange={(e) =>
//                   handleBillingChange("flat_fee", numericOnlyString(e.target.value))
//                 }
//                 error={!!billingErrors.flat_fee}
//                 helperText={billingErrors.flat_fee || "Numbers only"}
//                 inputProps={{ inputMode: "decimal" }}
//               />
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Currency</InputLabel>
//                 <Select
//                   label="Currency"
//                   value={billingForm.currency}
//                   onChange={(e) => handleBillingChange("currency", e.target.value)}
//                 >
//                   {CURRENCY_OPTIONS.map((currency) => (
//                     <MenuItem key={currency} value={currency}>
//                       {currency}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <FormControlLabel
//                 sx={{ mt: 1 }}
//                 control={
//                   <Switch
//                     checked={billingForm.is_invoiced}
//                     onChange={(e) =>
//                       handleBillingChange("is_invoiced", e.target.checked)
//                     }
//                   />
//                 }
//                 label="Is Invoiced"
//               />
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <TextField
//                 fullWidth
//                 label="Invoice Number"
//                 value={billingForm.invoice_number}
//                 onChange={(e) => handleBillingChange("invoice_number", e.target.value)}
//                 error={!!billingErrors.invoice_number}
//                 helperText={billingErrors.invoice_number}
//               />
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 type="date"
//                 label="Invoice Date"
//                 InputLabelProps={{ shrink: true }}
//                 value={billingForm.invoice_date}
//                 onChange={(e) => handleBillingChange("invoice_date", e.target.value)}
//                 error={!!billingErrors.invoice_date}
//                 helperText={billingErrors.invoice_date}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 multiline
//                 minRows={3}
//                 label="Notes"
//                 value={billingForm.notes}
//                 onChange={(e) => handleBillingChange("notes", e.target.value)}
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setBillingDialogOpen(false)}>Cancel</Button>
//           <Button
//             variant="contained"
//             onClick={handleSaveBilling}
//             disabled={billingSaving}
//           >
//             {billingSaving ? "Saving..." : "Save Billing"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={3500}
//         onClose={closeSnackbar}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//       >
//         <Alert
//           onClose={closeSnackbar}
//           severity={snackbar.severity}
//           variant="filled"
//           sx={{ width: "100%" }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default WebsiteManagement;




















import React, { useEffect, useMemo, useState } from "react";
import {
  Alert, Box, Button, Card, CardContent, Chip, CircularProgress, Dialog, DialogActions,
  DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, Grid, IconButton,
  InputAdornment, InputLabel, MenuItem, Select, Snackbar, Stack, Switch, Tab, Tabs,
  TextField, Tooltip, Typography, Accordion, AccordionSummary, AccordionDetails, Paper,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import RefreshIcon from "@mui/icons-material/Refresh";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HistoryIcon from "@mui/icons-material/History";
import LanguageIcon from "@mui/icons-material/Language";
import SearchIcon from "@mui/icons-material/Search";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import DnsOutlinedIcon from "@mui/icons-material/DnsOutlined";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";

import { getDecryptedAccessToken } from "../../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import ApiServices from "../../../../Utils/ApiServices/ApiServices";

/* ─── theme tokens ─── */
const accent = "#0d47a1";
const accentLight = "#e3f2fd";
const accentDark = "#082f6c";
const gradientHeader = `linear-gradient(135deg, ${accent}, #1565c0)`;

const sectionCard = {
  borderRadius: "16px",
  boxShadow: "0 4px 24px rgba(13,71,161,0.07)",
  border: `1px solid ${accentLight}`,
  overflow: "hidden",
};

const sectionHeader = {
  background: gradientHeader,
  color: "#fff",
  px: 3, py: 2.5,
  display: "flex", alignItems: "center", gap: 1.5,
};

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px", backgroundColor: "#f8f9fb",
    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: accent },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: accent, borderWidth: 2 },
  },
  "& .MuiInputLabel-root.Mui-focused": { color: accent },
};

const accentBtn = {
  backgroundColor: accent, borderRadius: "10px", textTransform: "none", fontWeight: 600, px: 3,
  "&:hover": { backgroundColor: accentDark },
};

const outlineBtn = {
  borderColor: accent, color: accent, borderRadius: "10px", textTransform: "none", fontWeight: 600,
  "&:hover": { backgroundColor: accentLight, borderColor: accent },
};

const dangerBtn = {
  borderColor: "#ef4444", color: "#ef4444", borderRadius: "10px", textTransform: "none", fontWeight: 600,
  "&:hover": { backgroundColor: "#fef2f2", borderColor: "#dc2626" },
};

const whiteBtn = {
  backgroundColor: "#fff", color: accent, borderRadius: "10px", textTransform: "none", fontWeight: 600,
  "&:hover": { backgroundColor: accentLight },
};

const ghostWhiteBtn = {
  borderColor: "rgba(255,255,255,0.4)", color: "#fff", borderRadius: "10px", textTransform: "none", fontWeight: 600,
  "&:hover": { backgroundColor: "rgba(255,255,255,0.12)" },
};

const switchSx = {
  "& .MuiSwitch-switchBase.Mui-checked": { color: accent },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: accent },
};

const subLabel = {
  color: accent, fontWeight: 700, mb: 2, textTransform: "uppercase", letterSpacing: 0.5, fontSize: 11,
};

/* ─── constants ─── */
const STATUS_OPTIONS = ["pending", "in_progress", "completed", "deployed"];
const CURRENCY_OPTIONS = ["INR", "USD", "EUR", "GBP", "AUD", "CAD"];

const initialWebsiteForm = {
  website_url: "", domain_provider: "", domain_login_url: "", domain_username: "", domain_password: "",
  hosting_provider: "", hosting_login_url: "", hosting_username: "", hosting_password: "", notes: "",
};
const initialChangeRequestForm = { title: "", description: "", requested_by: "", status: "pending", internal_notes: "" };
const initialVersionForm = { change_summary: "", files_changed: "", deployed_by: "", deployed_at: "" };
const initialBillingForm = { hours_spent: "", rate_per_hour: "", flat_fee: "", currency: "INR", is_invoiced: false, invoice_number: "", invoice_date: "", notes: "" };

const getStatusChip = (status) => {
  const map = {
    pending: { bg: "#fff3e0", color: "#e65100", icon: <InfoOutlinedIcon sx={{ fontSize: 14 }} /> },
    in_progress: { bg: accentLight, color: accent, icon: <PlayArrowIcon sx={{ fontSize: 14 }} /> },
    completed: { bg: "#e8f5e9", color: "#2e7d32", icon: <DoneAllIcon sx={{ fontSize: 14 }} /> },
    deployed: { bg: "#ede7f6", color: "#5e35b1", icon: <RocketLaunchIcon sx={{ fontSize: 14 }} /> },
  };
  const s = map[status] || { bg: "#f5f5f5", color: "#757575", icon: null };
  return (
    <Chip icon={s.icon} label={status?.replace("_", " ")} size="small"
      sx={{ backgroundColor: s.bg, color: s.color, fontWeight: 700, textTransform: "capitalize", border: `1px solid ${s.color}20` }} />
  );
};

const isValidUrl = (v) => { if (!v) return true; try { const p = new URL(v); return ["http:", "https:"].includes(p.protocol); } catch { return false; } };
const isValidEmail = (v) => { if (!v) return true; return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); };
const isValidDomainOrWebsite = (v) => { if (!v) return true; return /^(https?:\/\/)?(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})(:\d+)?(\/.*)?$/.test(v.trim()); };
const numericOnlyString = (v) => v.replace(/[^\d.]/g, "");
const formatDateTime = (v) => { if (!v) return "—"; const d = new Date(v); if (Number.isNaN(d.getTime())) return v; return d.toLocaleString(); };
const formatDate = (v) => { if (!v) return "—"; const d = new Date(v); if (Number.isNaN(d.getTime())) return v; return d.toLocaleDateString(); };
const safeArray = (v) => (Array.isArray(v) ? v : []);

/* ═══════════════════════════════════════════════════════ */
const WebsiteManagement = () => {
  const clientId = sessionStorage.getItem("activeClientId");
  const authHeaderstoken = getDecryptedAccessToken();
  const token = useMemo(() => ({ Authorization: `Bearer ${authHeaderstoken}`, "Content-Type": "application/json" }), [authHeaderstoken]);

  const [tabValue, setTabValue] = useState(0);
  const [loadingPage, setLoadingPage] = useState(false);

  const [websiteRecord, setWebsiteRecord] = useState(null);
  const [websiteExists, setWebsiteExists] = useState(false);
  const [websiteForm, setWebsiteForm] = useState(initialWebsiteForm);
  const [websiteErrors, setWebsiteErrors] = useState({});

  const [changeRequests, setChangeRequests] = useState([]);
  const [changeRequestFilter, setChangeRequestFilter] = useState("");
  const [changeRequestSearch, setChangeRequestSearch] = useState("");
  const [selectedChangeRequest, setSelectedChangeRequest] = useState(null);

  const [changeRequestDialogOpen, setChangeRequestDialogOpen] = useState(false);
  const [changeRequestMode, setChangeRequestMode] = useState("create");
  const [changeRequestForm, setChangeRequestForm] = useState(initialChangeRequestForm);
  const [changeRequestErrors, setChangeRequestErrors] = useState({});
  const [changeRequestSaving, setChangeRequestSaving] = useState(false);

  const [versionDialogOpen, setVersionDialogOpen] = useState(false);
  const [versionForm, setVersionForm] = useState(initialVersionForm);
  const [versionErrors, setVersionErrors] = useState({});
  const [versionSaving, setVersionSaving] = useState(false);

  const [billingDialogOpen, setBillingDialogOpen] = useState(false);
  const [billingMode, setBillingMode] = useState("create");
  const [billingForm, setBillingForm] = useState(initialBillingForm);
  const [billingErrors, setBillingErrors] = useState({});
  const [billingSaving, setBillingSaving] = useState(false);
  const [billingSummary, setBillingSummary] = useState(null);

  const [snackbar, setSnackbar] = useState({ open: false, severity: "success", message: "" });
  const baseUrl = useMemo(() => `/api/v1/clients/${clientId}`, [clientId]);

  const showSnackbar = (message, severity = "success") => setSnackbar({ open: true, message, severity });
  const closeSnackbar = () => setSnackbar((p) => ({ ...p, open: false }));
  const handleApiError = (error, fallback) => {
    const msg = error?.response?.data?.detail || error?.response?.data?.message || error?.message || fallback;
    showSnackbar(msg, "error");
  };

  const apiGet = (url) => ApiServices.get(url, token);
  const apiPost = (url, payload) => ApiServices.post(url, payload, token);
  const apiPut = (url, payload) => ApiServices.put(url, payload, token);
  const apiPatch = (url, payload) => ApiServices.patch(url, payload, token);
  const apiDelete = (url) => ApiServices.delete(url, token);

  /* ─── fetch ─── */
  const fetchWebsite = async () => {
    try {
      const res = await apiGet(`${baseUrl}/website/`);
      const data = res?.data || {};
      const exists = data && Object.keys(data).length > 0;
      setWebsiteExists(exists); setWebsiteRecord(exists ? data : null);
      setWebsiteForm({
        website_url: data?.website_url || "", domain_provider: data?.domain_provider || "",
        domain_login_url: data?.domain_login_url || "", domain_username: data?.domain_username || "", domain_password: "",
        hosting_provider: data?.hosting_provider || "", hosting_login_url: data?.hosting_login_url || "",
        hosting_username: data?.hosting_username || "", hosting_password: "", notes: data?.notes || "",
      });
    } catch (e) { handleApiError(e, "Failed to load website credentials."); }
  };

  const fetchChangeRequests = async () => {
    try {
      const q = changeRequestFilter ? `?status=${changeRequestFilter}` : "";
      const res = await apiGet(`${baseUrl}/change-requests/${q}`);
      setChangeRequests(Array.isArray(res?.data) ? res.data : []);
    } catch (e) { handleApiError(e, "Failed to load change requests."); }
  };

  const fetchBillingSummary = async () => {
    try { const res = await apiGet(`${baseUrl}/billing-summary/`); setBillingSummary(res?.data || null); }
    catch (e) { handleApiError(e, "Failed to load billing summary."); }
  };

  const fetchAll = async () => { setLoadingPage(true); try { await Promise.all([fetchWebsite(), fetchChangeRequests(), fetchBillingSummary()]); } finally { setLoadingPage(false); } };

  useEffect(() => { if (!clientId || !token) { showSnackbar("Missing client or token.", "error"); return; } fetchAll(); }, [clientId, token]);
  useEffect(() => { if (clientId && token) fetchChangeRequests(); }, [changeRequestFilter]);

  /* ─── validation ─── */
  const validateWebsiteForm = () => {
    const e = {};
    if (websiteForm.website_url && !isValidUrl(websiteForm.website_url)) e.website_url = "Enter a valid URL.";
    if (websiteForm.domain_login_url && !isValidUrl(websiteForm.domain_login_url)) e.domain_login_url = "Enter a valid URL.";
    if (websiteForm.hosting_login_url && !isValidUrl(websiteForm.hosting_login_url)) e.hosting_login_url = "Enter a valid URL.";
    if (websiteForm.domain_username?.includes("@") && !isValidEmail(websiteForm.domain_username)) e.domain_username = "Invalid email.";
    if (websiteForm.hosting_username?.includes("@") && !isValidEmail(websiteForm.hosting_username)) e.hosting_username = "Invalid email.";
    if (websiteForm.website_url && !isValidDomainOrWebsite(websiteForm.website_url)) e.website_url = "Enter a valid domain.";
    setWebsiteErrors(e); return Object.keys(e).length === 0;
  };

  const validateChangeRequestForm = () => {
    const e = {};
    if (!changeRequestForm.title.trim()) e.title = "Title is required.";
    if (!changeRequestForm.description.trim()) e.description = "Description is required.";
    if (!changeRequestForm.requested_by.trim()) e.requested_by = "Requested by is required.";
    if (!STATUS_OPTIONS.includes(changeRequestForm.status)) e.status = "Select a valid status.";
    setChangeRequestErrors(e); return Object.keys(e).length === 0;
  };

  const validateVersionForm = () => {
    const e = {};
    if (!versionForm.change_summary.trim()) e.change_summary = "Change summary is required.";
    if (versionForm.deployed_by?.includes("@") && !isValidEmail(versionForm.deployed_by)) e.deployed_by = "Invalid email.";
    setVersionErrors(e); return Object.keys(e).length === 0;
  };

  const validateBillingForm = () => {
    const e = {};
    if (billingForm.hours_spent !== "" && Number(billingForm.hours_spent) < 0) e.hours_spent = "Cannot be negative.";
    if (billingForm.rate_per_hour !== "" && Number(billingForm.rate_per_hour) < 0) e.rate_per_hour = "Cannot be negative.";
    if (billingForm.flat_fee !== "" && Number(billingForm.flat_fee) < 0) e.flat_fee = "Cannot be negative.";
    if (billingForm.invoice_number && billingForm.invoice_number.length > 50) e.invoice_number = "Too long.";
    if (billingForm.is_invoiced && !billingForm.invoice_number.trim()) e.invoice_number = "Required when invoiced.";
    if (billingForm.is_invoiced && !billingForm.invoice_date) e.invoice_date = "Required when invoiced.";
    setBillingErrors(e); return Object.keys(e).length === 0;
  };

  /* ─── handlers ─── */
  const handleWebsiteChange = (f, v) => { setWebsiteForm((p) => ({ ...p, [f]: v })); setWebsiteErrors((p) => ({ ...p, [f]: "" })); };
  const handleChangeRequestChange = (f, v) => { setChangeRequestForm((p) => ({ ...p, [f]: v })); setChangeRequestErrors((p) => ({ ...p, [f]: "" })); };
  const handleVersionChange = (f, v) => { setVersionForm((p) => ({ ...p, [f]: v })); setVersionErrors((p) => ({ ...p, [f]: "" })); };
  const handleBillingChange = (f, v) => { setBillingForm((p) => ({ ...p, [f]: v })); setBillingErrors((p) => ({ ...p, [f]: "" })); };

  const handleWebsiteSave = async () => {
    if (!validateWebsiteForm()) return;
    const payload = { ...websiteForm };
    if (!payload.domain_password) delete payload.domain_password;
    if (!payload.hosting_password) delete payload.hosting_password;
    try {
      if (websiteExists) { await apiPatch(`${baseUrl}/website/`, payload); showSnackbar("Credentials updated."); }
      else { await apiPost(`${baseUrl}/website/`, payload); showSnackbar("Credentials created."); }
      await fetchWebsite();
    } catch (e) { handleApiError(e, "Failed to save credentials."); }
  };

  const openCreateChangeRequestDialog = () => { setChangeRequestMode("create"); setChangeRequestForm(initialChangeRequestForm); setChangeRequestErrors({}); setChangeRequestDialogOpen(true); };
  const openEditChangeRequestDialog = (item) => {
    setSelectedChangeRequest(item); setChangeRequestMode("edit");
    setChangeRequestForm({ title: item?.title || "", description: item?.description || "", requested_by: item?.requested_by || "", status: item?.status || "pending", internal_notes: item?.internal_notes || "" });
    setChangeRequestErrors({}); setChangeRequestDialogOpen(true);
  };

  const handleSaveChangeRequest = async () => {
    if (!validateChangeRequestForm()) return;
    setChangeRequestSaving(true);
    try {
      const payload = { title: changeRequestForm.title.trim(), description: changeRequestForm.description.trim(), requested_by: changeRequestForm.requested_by.trim(), status: changeRequestForm.status, internal_notes: changeRequestForm.internal_notes?.trim() || "" };
      if (changeRequestMode === "create") { await apiPost(`${baseUrl}/change-requests/`, payload); showSnackbar("Request created."); }
      else { await apiPatch(`${baseUrl}/change-requests/${selectedChangeRequest?.id}/`, payload); showSnackbar("Request updated."); }
      setChangeRequestDialogOpen(false); await fetchChangeRequests(); await fetchBillingSummary();
    } catch (e) { handleApiError(e, "Failed to save request."); } finally { setChangeRequestSaving(false); }
  };

  const handleDeleteChangeRequest = async (item) => {
    if (!window.confirm(`Delete "${item?.title}"? This also deletes versions and billing.`)) return;
    try { await apiDelete(`${baseUrl}/change-requests/${item?.id}/`); showSnackbar("Request deleted."); await fetchChangeRequests(); await fetchBillingSummary(); }
    catch (e) { handleApiError(e, "Failed to delete request."); }
  };

  const handleQuickStatusUpdate = async (item, status) => {
    try { await apiPatch(`${baseUrl}/change-requests/${item?.id}/`, { status, internal_notes: item?.internal_notes || "" }); showSnackbar(`Status → ${status}.`); await fetchChangeRequests(); await fetchBillingSummary(); }
    catch (e) { handleApiError(e, "Failed to update status."); }
  };

  const openVersionDialog = (item) => { setSelectedChangeRequest(item); setVersionForm(initialVersionForm); setVersionErrors({}); setVersionDialogOpen(true); };

  const handleSaveVersion = async () => {
    if (!validateVersionForm()) return;
    setVersionSaving(true);
    try {
      const payload = { change_summary: versionForm.change_summary.trim(), files_changed: versionForm.files_changed ? versionForm.files_changed.split(",").map((f) => f.trim()).filter(Boolean) : [], deployed_by: versionForm.deployed_by.trim(), deployed_at: versionForm.deployed_at ? new Date(versionForm.deployed_at).toISOString() : undefined };
      if (!payload.deployed_by) delete payload.deployed_by; if (!payload.deployed_at) delete payload.deployed_at;
      await apiPost(`${baseUrl}/change-requests/${selectedChangeRequest?.id}/versions/`, payload);
      showSnackbar("Version added."); setVersionDialogOpen(false); await fetchChangeRequests();
    } catch (e) { handleApiError(e, "Failed to add version."); } finally { setVersionSaving(false); }
  };

  const openBillingDialog = async (item) => {
    setSelectedChangeRequest(item); setBillingErrors({});
    try {
      const res = await apiGet(`${baseUrl}/change-requests/${item?.id}/billing/`);
      const data = res?.data || {}; const exists = data && Object.keys(data).length > 0;
      setBillingMode(exists ? "edit" : "create");
      setBillingForm({ hours_spent: data?.hours_spent ?? "", rate_per_hour: data?.rate_per_hour ?? "", flat_fee: data?.flat_fee ?? "", currency: data?.currency || "INR", is_invoiced: !!data?.is_invoiced, invoice_number: data?.invoice_number || "", invoice_date: data?.invoice_date || "", notes: data?.notes || "" });
      setBillingDialogOpen(true);
    } catch (e) { handleApiError(e, "Failed to load billing."); }
  };

  const handleSaveBilling = async () => {
    if (!validateBillingForm()) return;
    setBillingSaving(true);
    try {
      const payload = { hours_spent: billingForm.hours_spent === "" ? 0 : Number(billingForm.hours_spent), rate_per_hour: billingForm.rate_per_hour === "" ? 0 : Number(billingForm.rate_per_hour), flat_fee: billingForm.flat_fee === "" ? 0 : Number(billingForm.flat_fee), currency: billingForm.currency, is_invoiced: !!billingForm.is_invoiced, invoice_number: billingForm.invoice_number.trim(), notes: billingForm.notes.trim() };
      if (billingForm.invoice_date) payload.invoice_date = billingForm.invoice_date;
      if (!payload.invoice_number) delete payload.invoice_number; if (!payload.notes) delete payload.notes; if (!payload.invoice_date) delete payload.invoice_date;
      if (billingMode === "create") { await apiPost(`${baseUrl}/change-requests/${selectedChangeRequest?.id}/billing/`, payload); showSnackbar("Billing created."); }
      else { await apiPatch(`${baseUrl}/change-requests/${selectedChangeRequest?.id}/billing/`, payload); showSnackbar("Billing updated."); }
      setBillingDialogOpen(false); await fetchChangeRequests(); await fetchBillingSummary();
    } catch (e) { handleApiError(e, "Failed to save billing."); } finally { setBillingSaving(false); }
  };

  const filteredChangeRequests = useMemo(() => {
    const s = changeRequestSearch.trim().toLowerCase();
    if (!s) return changeRequests;
    return changeRequests.filter((i) => i?.title?.toLowerCase().includes(s) || i?.description?.toLowerCase().includes(s) || i?.requested_by?.toLowerCase().includes(s) || i?.status?.toLowerCase().includes(s));
  }, [changeRequests, changeRequestSearch]);

  /* ═══════════════════ TAB 0: WEBSITE CREDENTIALS ═══════════════════ */
  const renderWebsiteCredentials = () => (
    <Paper sx={sectionCard}>
      <Box sx={{ ...sectionHeader, py: 2 }}>
        <LanguageIcon />
        <Box sx={{ flex: 1 }}>
          <Typography variant="h6" fontWeight={700}>Website Credentials</Typography>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>Store website, domain and hosting access details securely.</Typography>
        </Box>
        <Stack direction="row" spacing={1}>
          <Button variant="outlined" startIcon={<RefreshIcon />} sx={ghostWhiteBtn} onClick={fetchWebsite}>Refresh</Button>
          <Button variant="contained" startIcon={<SaveIcon />} sx={whiteBtn} onClick={handleWebsiteSave}>
            {websiteExists ? "Update" : "Save"}
          </Button>
        </Stack>
      </Box>

      <CardContent sx={{ p: 3 }}>
        <Alert icon={<LockOutlinedIcon />} severity="info"
          sx={{ mb: 3, borderRadius: "10px", backgroundColor: accentLight, color: accent, border: `1px solid ${accent}20`, "& .MuiAlert-icon": { color: accent } }}>
          Password fields are write-only. Leave blank to keep existing passwords unchanged.
        </Alert>

        {/* Website URL */}
        <Typography variant="subtitle2" sx={subLabel}>Website</Typography>
        <Grid container spacing={2.5} sx={{ mb: 3 }}>
          <Grid item xs={12}>
            <TextField fullWidth label="Website URL" placeholder="https://example.com" value={websiteForm.website_url} sx={inputSx}
              onChange={(e) => handleWebsiteChange("website_url", e.target.value)}
              error={!!websiteErrors.website_url} helperText={websiteErrors.website_url}
              InputProps={{ startAdornment: <InputAdornment position="start"><LanguageIcon sx={{ color: accent, fontSize: 18 }} /></InputAdornment> }} />
          </Grid>
        </Grid>

        {/* Domain */}
        <Typography variant="subtitle2" sx={subLabel}>Domain Access</Typography>
        <Grid container spacing={2.5} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Domain Provider" placeholder="GoDaddy" value={websiteForm.domain_provider} sx={inputSx}
              onChange={(e) => handleWebsiteChange("domain_provider", e.target.value)}
              InputProps={{ startAdornment: <InputAdornment position="start"><DnsOutlinedIcon sx={{ color: accent, fontSize: 18 }} /></InputAdornment> }} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Domain Login URL" placeholder="https://dcc.godaddy.com" value={websiteForm.domain_login_url} sx={inputSx}
              onChange={(e) => handleWebsiteChange("domain_login_url", e.target.value)}
              error={!!websiteErrors.domain_login_url} helperText={websiteErrors.domain_login_url} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Domain Username / Email" placeholder="admin@example.com" value={websiteForm.domain_username} sx={inputSx}
              onChange={(e) => handleWebsiteChange("domain_username", e.target.value)}
              error={!!websiteErrors.domain_username} helperText={websiteErrors.domain_username} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField fullWidth type="password" label="Domain Password" placeholder="Enter only if changing" value={websiteForm.domain_password} sx={inputSx}
              onChange={(e) => handleWebsiteChange("domain_password", e.target.value)}
              helperText="Leave blank to keep existing." />
          </Grid>
        </Grid>

        {/* Hosting */}
        <Typography variant="subtitle2" sx={subLabel}>Hosting Access</Typography>
        <Grid container spacing={2.5} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Hosting Provider" placeholder="SiteGround" value={websiteForm.hosting_provider} sx={inputSx}
              onChange={(e) => handleWebsiteChange("hosting_provider", e.target.value)}
              InputProps={{ startAdornment: <InputAdornment position="start"><StorageOutlinedIcon sx={{ color: accent, fontSize: 18 }} /></InputAdornment> }} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Hosting Login URL" placeholder="https://app.siteground.com" value={websiteForm.hosting_login_url} sx={inputSx}
              onChange={(e) => handleWebsiteChange("hosting_login_url", e.target.value)}
              error={!!websiteErrors.hosting_login_url} helperText={websiteErrors.hosting_login_url} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Hosting Username / Email" placeholder="hosting@example.com" value={websiteForm.hosting_username} sx={inputSx}
              onChange={(e) => handleWebsiteChange("hosting_username", e.target.value)}
              error={!!websiteErrors.hosting_username} helperText={websiteErrors.hosting_username} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField fullWidth type="password" label="Hosting Password" placeholder="Enter only if changing" value={websiteForm.hosting_password} sx={inputSx}
              onChange={(e) => handleWebsiteChange("hosting_password", e.target.value)}
              helperText="Leave blank to keep existing." />
          </Grid>
        </Grid>

        {/* Notes */}
        <Typography variant="subtitle2" sx={subLabel}>Additional Notes</Typography>
        <TextField fullWidth multiline minRows={4} label="Notes" placeholder="Renewal info, access notes…" value={websiteForm.notes} sx={inputSx}
          onChange={(e) => handleWebsiteChange("notes", e.target.value)} />
      </CardContent>
    </Paper>
  );

  /* ═══════════════════ TAB 1: CHANGE REQUESTS ═══════════════════ */
  const renderChangeRequests = () => (
    <Paper sx={sectionCard}>
      <Box sx={{ ...sectionHeader, py: 2 }}>
        <PublishedWithChangesIcon />
        <Box sx={{ flex: 1 }}>
          <Typography variant="h6" fontWeight={700}>Change Requests</Typography>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>Track website updates from request to deployment.</Typography>
        </Box>
        <Stack direction="row" spacing={1}>
          <Button variant="outlined" startIcon={<RefreshIcon />} sx={ghostWhiteBtn} onClick={fetchChangeRequests}>Refresh</Button>
          <Button variant="contained" startIcon={<AddIcon />} sx={whiteBtn} onClick={openCreateChangeRequestDialog}>Add Request</Button>
        </Stack>
      </Box>

      <CardContent sx={{ p: 3 }}>
        {/* Filters */}
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mb: 3 }}>
          <TextField size="small" placeholder="Search requests…" value={changeRequestSearch} sx={{ ...inputSx, flex: 1 }}
            onChange={(e) => setChangeRequestSearch(e.target.value)}
            InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon sx={{ fontSize: 18, color: accent }} /></InputAdornment> }} />
          <FormControl size="small" sx={{ minWidth: 180, ...inputSx }}>
            <InputLabel>Status Filter</InputLabel>
            <Select label="Status Filter" value={changeRequestFilter} onChange={(e) => setChangeRequestFilter(e.target.value)}>
              <MenuItem value="">All</MenuItem>
              {STATUS_OPTIONS.map((s) => <MenuItem key={s} value={s}>{s.replace("_", " ")}</MenuItem>)}
            </Select>
          </FormControl>
        </Stack>

        {filteredChangeRequests.length === 0 ? (
          <Box sx={{ py: 6, textAlign: "center" }}>
            <PublishedWithChangesIcon sx={{ fontSize: 48, color: "#ccc", mb: 1 }} />
            <Typography variant="h6" color="text.secondary" fontWeight={600}>No Change Requests</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>Create your first request to start tracking updates.</Typography>
            <Button variant="contained" startIcon={<AddIcon />} sx={accentBtn} onClick={openCreateChangeRequestDialog}>Create First Request</Button>
          </Box>
        ) : (
          <Stack spacing={2}>
            {filteredChangeRequests.map((item) => (
              <Accordion key={item.id} sx={{ borderRadius: "14px !important", boxShadow: "none", border: `1px solid ${accentLight}`, "&:before": { display: "none" }, overflow: "hidden" }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: accent }} />} sx={{ "&:hover": { backgroundColor: `${accentLight}50` } }}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={4}>
                      <Typography fontWeight={700}>{item.title}</Typography>
                      <Typography variant="caption" color="text.secondary">By: {item.requested_by || "—"}</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>{getStatusChip(item.status)}</Grid>
                    <Grid item xs={12} md={5}>
                      <Typography variant="caption" color="text.secondary">Requested: {formatDateTime(item.requested_at)}</Typography>
                      <Typography variant="caption" color="text.secondary" display="block">Updated: {formatDateTime(item.updated_at)}</Typography>
                    </Grid>
                  </Grid>
                </AccordionSummary>

                <AccordionDetails sx={{ backgroundColor: "#fafbfd", borderTop: `1px solid ${accentLight}` }}>
                  <Stack spacing={2.5}>
                    {/* Description & notes */}
                    <Paper sx={{ p: 2.5, borderRadius: "12px", border: `1px solid ${accentLight}` }}>
                      <Typography variant="subtitle2" sx={{ color: accent, fontWeight: 700, mb: 0.5 }}>Description</Typography>
                      <Typography variant="body2" color="text.secondary">{item.description || "—"}</Typography>
                      <Divider sx={{ my: 1.5 }} />
                      <Typography variant="subtitle2" sx={{ color: accent, fontWeight: 700, mb: 0.5 }}>Internal Notes</Typography>
                      <Typography variant="body2" color="text.secondary">{item.internal_notes || "—"}</Typography>
                      <Divider sx={{ my: 1.5 }} />
                      <Grid container spacing={1.5}>
                        <Grid item xs={12} md={4}><Typography variant="caption"><strong>Completed:</strong> {formatDateTime(item.completed_at)}</Typography></Grid>
                        <Grid item xs={12} md={4}><Typography variant="caption"><strong>Deployed:</strong> {formatDateTime(item.deployed_at)}</Typography></Grid>
                        <Grid item xs={12} md={4}><Typography variant="caption"><strong>Created:</strong> {formatDateTime(item.created_at)}</Typography></Grid>
                      </Grid>
                    </Paper>

                    {/* Actions */}
                    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                      <Button variant="outlined" size="small" startIcon={<EditIcon />} sx={outlineBtn} onClick={() => openEditChangeRequestDialog(item)}>Edit</Button>
                      <Button variant="outlined" size="small" startIcon={<HistoryIcon />} sx={outlineBtn} onClick={() => openVersionDialog(item)}>Add Version</Button>
                      <Button variant="outlined" size="small" startIcon={<ReceiptLongIcon />} sx={outlineBtn} onClick={() => openBillingDialog(item)}>Billing</Button>
                      {item.status !== "in_progress" && <Button variant="outlined" size="small" startIcon={<PlayArrowIcon />} sx={outlineBtn} onClick={() => handleQuickStatusUpdate(item, "in_progress")}>In Progress</Button>}
                      {item.status !== "completed" && <Button variant="outlined" size="small" startIcon={<DoneAllIcon />} sx={{ ...outlineBtn, borderColor: "#2e7d32", color: "#2e7d32", "&:hover": { backgroundColor: "#e8f5e9" } }} onClick={() => handleQuickStatusUpdate(item, "completed")}>Completed</Button>}
                      {item.status !== "deployed" && <Button variant="contained" size="small" startIcon={<RocketLaunchIcon />} sx={accentBtn} onClick={() => handleQuickStatusUpdate(item, "deployed")}>Deploy</Button>}
                      <Button variant="outlined" size="small" startIcon={<DeleteIcon />} sx={dangerBtn} onClick={() => handleDeleteChangeRequest(item)}>Delete</Button>
                    </Stack>

                    {/* Versions & Billing */}
                    <Grid container spacing={2.5}>
                      <Grid item xs={12} md={6}>
                        <Paper sx={{ borderRadius: "12px", border: `1px solid ${accentLight}`, overflow: "hidden" }}>
                          <Box sx={{ px: 2.5, py: 1.5, backgroundColor: accentLight, borderBottom: `1px solid ${accent}20` }}>
                            <Typography fontWeight={700} fontSize={14} color={accent}>Versions</Typography>
                          </Box>
                          <Box sx={{ p: 2 }}>
                            {safeArray(item.versions).length === 0 ? (
                              <Typography variant="body2" color="text.secondary">No versions yet.</Typography>
                            ) : (
                              <Stack spacing={1.5}>
                                {item.versions.map((v) => (
                                  <Paper key={v.id} sx={{ p: 1.5, borderRadius: "10px", border: `1px solid ${accentLight}` }}>
                                    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 0.5 }}>
                                      <Chip size="small" label={v.version_tag} sx={{ backgroundColor: accentLight, color: accent, fontWeight: 600 }} />
                                      <Typography variant="caption" color="text.secondary">{formatDateTime(v.deployed_at)}</Typography>
                                    </Stack>
                                    <Typography fontWeight={600} variant="body2">{v.change_summary}</Typography>
                                    <Typography variant="caption" color="text.secondary">By: {v.deployed_by || "—"}</Typography>
                                    <Typography variant="caption" color="text.secondary" display="block">Files: {safeArray(v.files_changed).length > 0 ? v.files_changed.join(", ") : "—"}</Typography>
                                  </Paper>
                                ))}
                              </Stack>
                            )}
                          </Box>
                        </Paper>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Paper sx={{ borderRadius: "12px", border: `1px solid ${accentLight}`, overflow: "hidden" }}>
                          <Box sx={{ px: 2.5, py: 1.5, backgroundColor: accentLight, borderBottom: `1px solid ${accent}20` }}>
                            <Typography fontWeight={700} fontSize={14} color={accent}>Billing</Typography>
                          </Box>
                          <Box sx={{ p: 2 }}>
                            {item.billing ? (
                              <Stack spacing={0.5}>
                                {[["Hours", item.billing.hours_spent], ["Rate/Hr", item.billing.rate_per_hour], ["Flat Fee", item.billing.flat_fee],
                                  ["Total", `${item.billing.total_amount ?? "—"} ${item.billing.currency || ""}`],
                                  ["Invoiced", item.billing.is_invoiced ? "Yes" : "No"], ["Invoice #", item.billing.invoice_number || "—"],
                                  ["Invoice Date", formatDate(item.billing.invoice_date)], ["Notes", item.billing.notes || "—"]
                                ].map(([label, val]) => (
                                  <Typography key={label} variant="body2"><strong>{label}:</strong> {val ?? "—"}</Typography>
                                ))}
                              </Stack>
                            ) : (
                              <Typography variant="body2" color="text.secondary">No billing added yet.</Typography>
                            )}
                          </Box>
                        </Paper>
                      </Grid>
                    </Grid>
                  </Stack>
                </AccordionDetails>
              </Accordion>
            ))}
          </Stack>
        )}
      </CardContent>
    </Paper>
  );

  /* ═══════════════════ TAB 2: BILLING SUMMARY ═══════════════════ */
  const renderBillingSummary = () => (
    <Paper sx={sectionCard}>
      <Box sx={{ ...sectionHeader, py: 2 }}>
        <ReceiptLongIcon />
        <Box sx={{ flex: 1 }}>
          <Typography variant="h6" fontWeight={700}>Billing Summary</Typography>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>Overview of billed and unbilled totals across all requests.</Typography>
        </Box>
        <Button variant="outlined" startIcon={<RefreshIcon />} sx={ghostWhiteBtn} onClick={fetchBillingSummary}>Refresh</Button>
      </Box>

      <CardContent sx={{ p: 3 }}>
        {!billingSummary ? (
          <Box sx={{ py: 6, textAlign: "center" }}>
            <AttachMoneyIcon sx={{ fontSize: 48, color: "#ccc", mb: 1 }} />
            <Typography variant="h6" color="text.secondary" fontWeight={600}>No Billing Data</Typography>
            <Typography variant="body2" color="text.secondary">Billing summaries will appear here once requests have billing records.</Typography>
          </Box>
        ) : (
          <>
            <Grid container spacing={2.5} sx={{ mb: 3 }}>
              {[
                { label: "Total Billed", value: billingSummary.total_billed ?? 0, icon: <CheckCircleOutlineIcon />, color: "#2e7d32", bg: "#e8f5e9" },
                { label: "Total Unbilled", value: billingSummary.total_unbilled ?? 0, icon: <CancelOutlinedIcon />, color: "#e65100", bg: "#fff3e0" },
                { label: "Grand Total", value: billingSummary.grand_total ?? 0, icon: <AttachMoneyIcon />, color: accent, bg: accentLight },
              ].map((card) => (
                <Grid item xs={12} md={4} key={card.label}>
                  <Paper sx={{ p: 2.5, borderRadius: "14px", border: `1px solid ${card.color}20`, backgroundColor: card.bg }}>
                    <Stack direction="row" spacing={1.5} alignItems="center">
                      <Box sx={{ color: card.color }}>{card.icon}</Box>
                      <Box>
                        <Typography variant="body2" color="text.secondary">{card.label}</Typography>
                        <Typography fontWeight={800} fontSize="1.3rem" color={card.color}>
                          {card.value} {billingSummary.currency || ""}
                        </Typography>
                      </Box>
                    </Stack>
                  </Paper>
                </Grid>
              ))}
            </Grid>

            <Paper sx={{ borderRadius: "12px", border: `1px solid ${accentLight}`, overflow: "hidden" }}>
              <Box sx={{ px: 2.5, py: 1.5, backgroundColor: accentLight, borderBottom: `1px solid ${accent}20` }}>
                <Typography fontWeight={700} fontSize={14} color={accent}>Billing Records</Typography>
              </Box>
              <Box sx={{ p: 2.5 }}>
                {safeArray(billingSummary.records).length === 0 ? (
                  <Typography variant="body2" color="text.secondary">No records found.</Typography>
                ) : (
                  <Stack spacing={1.5}>
                    {billingSummary.records.map((r, i) => (
                      <Paper key={`${r.change_request_id}-${i}`} sx={{ p: 2, borderRadius: "10px", border: `1px solid ${accentLight}`, transition: "all 0.2s", "&:hover": { boxShadow: "0 4px 16px rgba(13,71,161,0.08)" } }}>
                        <Grid container spacing={1.5} alignItems="center">
                          <Grid item xs={12} md={3}>
                            <Typography fontWeight={700}>{r.title || "—"}</Typography>
                            <Box sx={{ mt: 0.5 }}>{getStatusChip(r.status)}</Box>
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <Typography variant="body2"><strong>Hours:</strong> {r.hours_spent ?? 0}</Typography>
                            <Typography variant="body2"><strong>Rate:</strong> {r.rate_per_hour ?? 0}</Typography>
                            <Typography variant="body2"><strong>Flat Fee:</strong> {r.flat_fee ?? 0}</Typography>
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <Typography variant="body2" fontWeight={700}><strong>Total:</strong> {r.total_amount ?? 0} {r.currency || ""}</Typography>
                            <Typography variant="body2"><strong>Invoiced:</strong> {r.is_invoiced ? "Yes" : "No"}</Typography>
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <Typography variant="body2"><strong>Invoice #:</strong> {r.invoice_number || "—"}</Typography>
                            <Typography variant="body2"><strong>Date:</strong> {formatDate(r.invoice_date)}</Typography>
                          </Grid>
                        </Grid>
                      </Paper>
                    ))}
                  </Stack>
                )}
              </Box>
            </Paper>
          </>
        )}
      </CardContent>
    </Paper>
  );

  /* ═══════════════════ MAIN RENDER ═══════════════════ */
  return (
    <Box sx={{ p: { xs: 1.5, md: 3 }, maxWidth: 1400, mx: "auto" }}>

      {/* Page Header */}
      <Paper sx={{ ...sectionCard, mb: 3 }}>
        <Box sx={sectionHeader}>
          <LanguageIcon sx={{ fontSize: 28 }} />
          <Box sx={{ flex: 1 }}>
            <Typography variant="h5" fontWeight={700}>Website Management</Typography>
            <Typography variant="body2" sx={{ opacity: 0.85, mt: 0.25 }}>
              Manage credentials, track change requests, versions, and billing in one place.
            </Typography>
          </Box>
          <Button variant="contained" startIcon={<RefreshIcon />}
            sx={{ backgroundColor: "rgba(255,255,255,0.15)", color: "#fff", borderRadius: "10px", textTransform: "none", fontWeight: 600, "&:hover": { backgroundColor: "rgba(255,255,255,0.25)" } }}
            onClick={fetchAll}>Refresh All</Button>
        </Box>

        <Box sx={{ px: 3, pt: 1, pb: 0 }}>
          <Tabs value={tabValue} onChange={(_, v) => setTabValue(v)} variant="scrollable" scrollButtons="auto"
            sx={{
              "& .MuiTab-root": { textTransform: "none", fontWeight: 600, minHeight: 48, borderRadius: "10px 10px 0 0" },
              "& .Mui-selected": { color: `${accent} !important` },
              "& .MuiTabs-indicator": { backgroundColor: accent, height: 3, borderRadius: "3px 3px 0 0" },
            }}>
            <Tab icon={<LanguageIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="Credentials" />
            <Tab icon={<PublishedWithChangesIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="Change Requests" />
            <Tab icon={<ReceiptLongIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="Billing" />
          </Tabs>
        </Box>
      </Paper>

      {/* Content */}
      {loadingPage ? (
        <Box sx={{ py: 12, display: "flex", justifyContent: "center", alignItems: "center", gap: 2 }}>
          <CircularProgress size={32} sx={{ color: accent }} />
          <Typography color="text.secondary" fontWeight={500}>Loading…</Typography>
        </Box>
      ) : (
        <>
          {tabValue === 0 && renderWebsiteCredentials()}
          {tabValue === 1 && renderChangeRequests()}
          {tabValue === 2 && renderBillingSummary()}
        </>
      )}

      {/* ─── CHANGE REQUEST DIALOG ─── */}
      <Dialog open={changeRequestDialogOpen} onClose={() => setChangeRequestDialogOpen(false)} fullWidth maxWidth="md"
        PaperProps={{ sx: { borderRadius: "16px", overflow: "hidden" } }}>
        <Box sx={sectionHeader}>
          <PublishedWithChangesIcon />
          <Typography variant="h6" fontWeight={700}>{changeRequestMode === "create" ? "New Change Request" : "Edit Change Request"}</Typography>
        </Box>
        <DialogContent sx={{ p: 3 }}>
          <Grid container spacing={2.5}>
            <Grid item xs={12} md={8}>
              <TextField fullWidth label="Title" value={changeRequestForm.title} sx={inputSx}
                onChange={(e) => handleChangeRequestChange("title", e.target.value)}
                error={!!changeRequestErrors.title} helperText={changeRequestErrors.title} />
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth error={!!changeRequestErrors.status} sx={inputSx}>
                <InputLabel>Status</InputLabel>
                <Select label="Status" value={changeRequestForm.status} onChange={(e) => handleChangeRequestChange("status", e.target.value)}>
                  {STATUS_OPTIONS.map((s) => <MenuItem key={s} value={s}>{s.replace("_", " ")}</MenuItem>)}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth label="Requested By" placeholder="John Doe" value={changeRequestForm.requested_by} sx={inputSx}
                onChange={(e) => handleChangeRequestChange("requested_by", e.target.value)}
                error={!!changeRequestErrors.requested_by} helperText={changeRequestErrors.requested_by} />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth multiline minRows={4} label="Description" value={changeRequestForm.description} sx={inputSx}
                onChange={(e) => handleChangeRequestChange("description", e.target.value)}
                error={!!changeRequestErrors.description} helperText={changeRequestErrors.description} />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth multiline minRows={3} label="Internal Notes" value={changeRequestForm.internal_notes} sx={inputSx}
                onChange={(e) => handleChangeRequestChange("internal_notes", e.target.value)} />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #eee" }}>
          <Button onClick={() => setChangeRequestDialogOpen(false)} sx={outlineBtn}>Cancel</Button>
          <Button variant="contained" onClick={handleSaveChangeRequest} disabled={changeRequestSaving}
            startIcon={changeRequestSaving ? <CircularProgress size={16} color="inherit" /> : <SaveIcon />}
            sx={accentBtn}>{changeRequestSaving ? "Saving…" : "Save"}</Button>
        </DialogActions>
      </Dialog>

      {/* ─── VERSION DIALOG ─── */}
      <Dialog open={versionDialogOpen} onClose={() => setVersionDialogOpen(false)} fullWidth maxWidth="md"
        PaperProps={{ sx: { borderRadius: "16px", overflow: "hidden" } }}>
        <Box sx={sectionHeader}>
          <HistoryIcon />
          <Typography variant="h6" fontWeight={700}>Add Version</Typography>
        </Box>
        <DialogContent sx={{ p: 3 }}>
          <Grid container spacing={2.5}>
            <Grid item xs={12}>
              <TextField fullWidth multiline minRows={3} label="Change Summary" value={versionForm.change_summary} sx={inputSx}
                onChange={(e) => handleVersionChange("change_summary", e.target.value)}
                error={!!versionErrors.change_summary} helperText={versionErrors.change_summary} />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth label="Files Changed" placeholder="index.html, src/Hero.jsx" value={versionForm.files_changed} sx={inputSx}
                onChange={(e) => handleVersionChange("files_changed", e.target.value)}
                helperText="Comma separated file paths." />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth label="Deployed By" placeholder="dev@company.com" value={versionForm.deployed_by} sx={inputSx}
                onChange={(e) => handleVersionChange("deployed_by", e.target.value)}
                error={!!versionErrors.deployed_by} helperText={versionErrors.deployed_by} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth type="datetime-local" label="Deployed At" InputLabelProps={{ shrink: true }} value={versionForm.deployed_at} sx={inputSx}
                onChange={(e) => handleVersionChange("deployed_at", e.target.value)} />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #eee" }}>
          <Button onClick={() => setVersionDialogOpen(false)} sx={outlineBtn}>Cancel</Button>
          <Button variant="contained" onClick={handleSaveVersion} disabled={versionSaving}
            startIcon={versionSaving ? <CircularProgress size={16} color="inherit" /> : <SaveIcon />}
            sx={accentBtn}>{versionSaving ? "Saving…" : "Save Version"}</Button>
        </DialogActions>
      </Dialog>

      {/* ─── BILLING DIALOG ─── */}
      <Dialog open={billingDialogOpen} onClose={() => setBillingDialogOpen(false)} fullWidth maxWidth="md"
        PaperProps={{ sx: { borderRadius: "16px", overflow: "hidden" } }}>
        <Box sx={sectionHeader}>
          <ReceiptLongIcon />
          <Typography variant="h6" fontWeight={700}>{billingMode === "create" ? "Create Billing" : "Update Billing"}</Typography>
        </Box>
        <DialogContent sx={{ p: 3 }}>
          <Grid container spacing={2.5}>
            <Grid item xs={12} md={4}>
              <TextField fullWidth label="Hours Spent" value={billingForm.hours_spent} sx={inputSx}
                onChange={(e) => handleBillingChange("hours_spent", numericOnlyString(e.target.value))}
                error={!!billingErrors.hours_spent} helperText={billingErrors.hours_spent || "Numbers only"} inputProps={{ inputMode: "decimal" }} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth label="Rate Per Hour" value={billingForm.rate_per_hour} sx={inputSx}
                onChange={(e) => handleBillingChange("rate_per_hour", numericOnlyString(e.target.value))}
                error={!!billingErrors.rate_per_hour} helperText={billingErrors.rate_per_hour || "Numbers only"} inputProps={{ inputMode: "decimal" }} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth label="Flat Fee" value={billingForm.flat_fee} sx={inputSx}
                onChange={(e) => handleBillingChange("flat_fee", numericOnlyString(e.target.value))}
                error={!!billingErrors.flat_fee} helperText={billingErrors.flat_fee || "Numbers only"} inputProps={{ inputMode: "decimal" }} />
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth sx={inputSx}>
                <InputLabel>Currency</InputLabel>
                <Select label="Currency" value={billingForm.currency} onChange={(e) => handleBillingChange("currency", e.target.value)}>
                  {CURRENCY_OPTIONS.map((c) => <MenuItem key={c} value={c}>{c}</MenuItem>)}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <Paper sx={{ px: 2.5, py: 1.5, minHeight: 56, display: "flex", alignItems: "center", borderRadius: "10px", border: `1px solid ${billingForm.is_invoiced ? "#a5d6a7" : "#e0e0e0"}`, backgroundColor: billingForm.is_invoiced ? "#f1f8e9" : "#fafafa" }}>
                <FormControlLabel control={<Switch checked={billingForm.is_invoiced} sx={switchSx} onChange={(e) => handleBillingChange("is_invoiced", e.target.checked)} />}
                  label={<Typography fontWeight={600} fontSize={14}>{billingForm.is_invoiced ? "Invoiced" : "Not Invoiced"}</Typography>} />
              </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth label="Invoice Number" value={billingForm.invoice_number} sx={inputSx}
                onChange={(e) => handleBillingChange("invoice_number", e.target.value)}
                error={!!billingErrors.invoice_number} helperText={billingErrors.invoice_number} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth type="date" label="Invoice Date" InputLabelProps={{ shrink: true }} value={billingForm.invoice_date} sx={inputSx}
                onChange={(e) => handleBillingChange("invoice_date", e.target.value)}
                error={!!billingErrors.invoice_date} helperText={billingErrors.invoice_date} />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth multiline minRows={3} label="Notes" value={billingForm.notes} sx={inputSx}
                onChange={(e) => handleBillingChange("notes", e.target.value)} />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #eee" }}>
          <Button onClick={() => setBillingDialogOpen(false)} sx={outlineBtn}>Cancel</Button>
          <Button variant="contained" onClick={handleSaveBilling} disabled={billingSaving}
            startIcon={billingSaving ? <CircularProgress size={16} color="inherit" /> : <SaveIcon />}
            sx={accentBtn}>{billingSaving ? "Saving…" : "Save Billing"}</Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar open={snackbar.open} autoHideDuration={3500} onClose={closeSnackbar} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <Alert onClose={closeSnackbar} severity={snackbar.severity} variant="filled" sx={{ borderRadius: "10px", fontWeight: 600 }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default WebsiteManagement;
